import styled from 'styled-components';
import { Button } from '@tvg/fuse-design/buttons';
import { gridConfig } from '@tvg/fuse-design/responsive-grid';

const ChipsBox = styled.div`
  margin-bottom: var(--spacing-space16);
`;

const ChipListStyled = styled.ul`
  margin-top: var(--spacing-space24);
  margin-bottom: var(--spacing-space8);

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    margin-top: 0;
  }

  li {
    display: inline;
  }
`;

const ChipButtonStyled = styled(Button)`
   && {
    background: var(--color-global-grey200);
    border-radius: 20px;
    color: var(--color-global-black);
    font-size: var(--font-size-1);
    font-weight: var(--font-weight-paragraph);
    line-height: var(--font-line-height-1);
    padding: calc(var(--spacing-space8) - 1px) calc(var(--spacing-space12) - 1px);
    margin-right: var(--spacing-space8);
    margin-bottom: var(--spacing-space8);
    border: 1px solid var(--color-global-grey200);

    &:before {
      background: var(--color-global-black);
    }

    &:hover {
      border: 1px solid var(--color-global-grey500);
      background: var(--color-global-grey200);
      box-shadow: none;
    }

    &:focus {
      background-color: var(--color-global-grey200);
      box-shadow: none;
    }

    &:active {
      color: var(--color-global-black);
      border: 1px solid var(--color-global-black);
      background-color: var(--color-global-grey200);
      box-shadow: none

      &:before {
        background: var(--color-global-black);
      }
    }
  }
`;

const ClearAllButtonStyled = styled(Button)`
  && {
    background: none;
    border: 0;
    padding: 0;
    color: var(--color-global-grey900);
    border-radius: 0;

    font-weight: var(--font-weight-paragraph);
    text-decoration-line: underline;
    text-decoration-color: var(--color-global-grey500);
    text-decoration-style: solid;
    text-decoration-thickness: 1px;
    text-underline-offset: 7px; /* copied from reviews */
    font-size: var(--font-size-1);

    &:hover,
    &:active {
      border: 0;
      box-shadow: none;
    }

    &:active {
      color: var(--color-global-black);
      text-decoration-line: underline;
      text-decoration-color: var(--color-global-black);
    }

    &:hover,
    &:focus {
      color: var(--color-brand-dark);
      text-decoration-color: var(--color-brand-dark);
    }
  }
`;

export { ChipsBox, ChipListStyled, ChipButtonStyled, ClearAllButtonStyled };
